<script lang="ts">
	import { run } from "svelte/legacy"

	import {
		DataHandlerDevice,
		DataHandlerSnapshot,
		type Calibration,
		type Snapshot,
	} from "luxedo-data"
	import CalibrationSnapshots from "./CalibrationSnapshots.svelte"
	import CalibrationMasks from "./CalibrationMasks.svelte"
	import { DeviceSnapshotManager } from "../../../../../../modules/device-operation-managers/DeviceSnapshotManager"
	import { rerunCalibration } from "../../../../../reusable/overlays/calibration"

	interface Props {
		calibration: Calibration
	}

	let { calibration }: Props = $props()
	let snapshots: Array<Snapshot> = $state()

	DeviceSnapshotManager.subscribe(() => {
		setTimeout(() => {
			snapshots = DataHandlerSnapshot.filterByCalibration(calibration.id)
		})
	})

	run(() => {
		snapshots = DataHandlerSnapshot.filterByCalibration(calibration.id)
	})

	function rerunCal() {
		rerunCalibration(DataHandlerDevice.get(calibration.dev_id), calibration.id)
	}
</script>

<div class="cal-entry" id="cal-entry-{calibration.id}">
	<div class="flex-row">
		<h3>
			{calibration.runTime.toFormat("DDD")} at {calibration.runTime.toFormat("hh:mm a")}
		</h3>
		{#if import.meta.env.DEV}
			<button
				class="outline-button small alt"
				title="Rerun calibration"
				onclick={() => {
					rerunCal()
				}}
			>
				Rerun Cal (DEV)
			</button>
		{/if}
	</div>
	<CalibrationSnapshots
		{snapshots}
		device={DataHandlerDevice.get(calibration.dev_id)}
		{calibration}
	/>
	{#if snapshots.length}
		<CalibrationMasks {calibration} />
	{/if}
</div>

<style>
	h3 {
		font-size: var(--h2);
		color: var(--color-text);
		margin: 0;
		position: sticky;
		top: -1px;
		padding: 1rem 0 0.5rem 0;
		background-color: var(--color-bg-dark);
		z-index: 1;
		grid-column: 1/3;
	}

	.flex-row {
		justify-content: space-between;
	}

	/* .cal-entry {
		display: grid;
		grid-template-columns: 1fr 1fr;
	}

	.cal-entry :global(.snapshots-container) {
		margin-right: 0.5rem;
		height: fit-content;
	}

	.cal-entry :global(.masks-container) {
		margin-left: 0.5rem;
		height: fit-content;
	} */

	.cal-entry :global(.button-container) {
		align-items: center;
		flex-direction: row;
	}

	.cal-entry :global(.snapshots-container) {
		margin-bottom: 1rem;
	}

	:global(.isMobile) .cal-entry :global(.snapshots-container) {
		margin-bottom: 0.25rem;
		padding: 0.25rem;
	}

	:global(.isMobile) .cal-entry :global(.masks-container) {
		margin-top: 0.25rem;
		padding: 0.25rem;
	}
</style>
